import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { getTheme } from '../../reducers/theme'

const styles = () => {
  return {
    button: {
      borderRadius: '50px',
      width: '100%',
      fontSize: '14px',
      minHeight: '40px',
      height: '100%',
      border: 0,
      outline: 0,
      transitionDuration: '0.4s',
      '&:hover': {
        opacity: 0.85,
      },
    },
    buttonNormal: {
      cursor: 'pointer',
    },
    buttonDisabled: {
      cursor: 'not-allowed',
    },
    buttonPrimary: {
      color: 'white',
    },
    buttonSecondary: {},
  }
}

const mapStateToProps = (state) => {
  return {
    theme: getTheme(state),
  }
}

@connect(mapStateToProps)
@injectSheet(styles)
class StyleButton extends Component {
  static defaultProps = {
    styleType: 'primary',
  }

  handleClick = () => {
    const { onClick, disabled } = this.props
    if (disabled) {
      return
    }
    if (onClick) {
      onClick()
    }
  }

  render() {
    const {
      classes, theme, name, styleType, disabled = false,
    } = this.props
    return (
      <button
        type={'button'}
        className={classNames(classes.button, {
          [classes.buttonPrimary]: styleType === 'primary',
          [classes.buttonSecondary]: styleType === 'secondary',
          [classes.buttonNormal]: !disabled,
          [classes.buttonDisabled]: disabled,
        })}
        style={{
          background:
            styleType === 'primary'
              ? `linear-gradient(-90deg, ${theme.gradient_color_1}, ${theme.gradient_color_2})`
              : 'none',
          border: styleType === 'secondary' ? `solid 1px ${theme.primary_color}` : 'none',
          color: styleType === 'secondary' ? `${theme.primary_color}` : 'inherit',
        }}
        onClick={this.handleClick}
        disabled={disabled}
      >
        {name}
      </button>
    )
  }
}

StyleButton.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
  name: PropTypes.string,
  styleType: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default StyleButton
